import { render, staticRenderFns } from "./wy-bes_bas-default-targets.vue?vue&type=template&id=b8254180&"
import script from "./wy-bes_bas-default-targets.vue?vue&type=script&lang=js&"
export * from "./wy-bes_bas-default-targets.vue?vue&type=script&lang=js&"
import style0 from "./wy-bes_bas-default-targets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports